/* eslint-disable brace-style */
// Conflicting with prettier..
import { Component, OnInit, inject } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {
  AbstractFormDialog,
  AbstractFormDialogData,
  AbstractDialogResultData,
  DIALOG_RETURN_TYPES,
} from '@next/core-lib/dialog';

import {
  SoilType,
  UnitOfMeasure,
  NutrientDesignation,
  NitrogenModelProperties,
  UpsertNitrogenModelPropertiesRequest,
  SoilTargetUoMEnum,
  NutrientDesignationEnum,
} from '../../models';

export interface CreateNitrogenModelPropertyDialogData extends AbstractFormDialogData {
  soilTypes: SoilType[];
  unitsOfMeasure: UnitOfMeasure[];
  nutrientDesignations: NutrientDesignation[];
  nitrogenModelProperties?: NitrogenModelProperties;
}

@Component({
  selector: 'app-create-nitrogen-model-property-dialog',
  templateUrl: './create-nitrogen-model-property-dialog.component.html',
  styleUrls: ['./create-nitrogen-model-property-dialog.component.scss'],
  standalone: false,
})
export class CreateNitrogenModelPropertyDialogComponent
  extends AbstractFormDialog<UpsertNitrogenModelPropertiesRequest>
  implements OnInit
{
  data = inject<CreateNitrogenModelPropertyDialogData>(MAT_DIALOG_DATA);
  private readonly formBuilder = inject(FormBuilder);
  protected readonly mdDialogRef =
    inject<
      MatDialogRef<
        CreateNitrogenModelPropertyDialogComponent,
        AbstractDialogResultData<UpsertNitrogenModelPropertiesRequest>
      >
    >(MatDialogRef);

  formGroup: FormGroup = this.formBuilder.group({
    nutrientDesignation: [null as string | null, Validators.required],
    soilTypeId: [null as number | null, Validators.required],
    soilTargetUoM: [null as string | null, Validators.required],
    nBasebuffer: [null as number | null, [Validators.min(0), Validators.max(99999)]],
    maxNbs: [null as number | null, [Validators.min(0), Validators.max(99999)]],
    maxNbsSeedPotato: [null as number | null, [Validators.min(0), Validators.max(99999)]],
  });

  filteredNutrientDesignations = this.data.nutrientDesignations.filter(
    (d) => d.designation === NutrientDesignationEnum.N,
  );
  filteredUnitsOfMeasure = this.data.unitsOfMeasure.filter(
    (unit) => unit.name === SoilTargetUoMEnum.KgPerHa,
  );

  ngOnInit(): void {
    if (this.data.nitrogenModelProperties) {
      const { soilType, ...rest } = this.data.nitrogenModelProperties;

      this.formGroup.patchValue({
        ...rest,
        soilTypeId: soilType.id,
      });
    }

    if (!this.formGroup.controls['soilTargetUoM'].value) {
      this.formGroup.controls['soilTargetUoM'].setValue(SoilTargetUoMEnum.KgPerHa);
    }
  }

  confirm(): void {
    if (this.formGroup.valid) {
      this.mdDialogRef.close({ status: DIALOG_RETURN_TYPES.confirm, result: this.formGroup.value });
    }
  }
}
